import { createIcon } from '@chakra-ui/react';

export const EyeIcon = createIcon({
  displayName: 'EyeIcon',
  path: (
    <>
      <svg viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_923_10914" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="13">
          <path d="M12 0.5H0V12.5H12V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask0_923_10914)">
          <path
            d="M5.99995 8.66495C4.80496 8.66495 3.83496 7.69495 3.83496 6.49995C3.83496 5.30496 4.80496 4.33496 5.99995 4.33496C7.19495 4.33496 8.16495 5.30496 8.16495 6.49995C8.16495 7.69495 7.19495 8.66495 5.99995 8.66495ZM5.99995 5.08496C5.21995 5.08496 4.58496 5.71995 4.58496 6.49995C4.58496 7.27995 5.21995 7.91495 5.99995 7.91495C6.77995 7.91495 7.41495 7.27995 7.41495 6.49995C7.41495 5.71995 6.77995 5.08496 5.99995 5.08496Z"
            fill="currentcolor"
          />
          <path
            d="M6.00005 11.0102C4.12004 11.0102 2.34504 9.91025 1.12504 8.00025C0.595039 7.17525 0.595039 5.83025 1.12504 5.00023C2.35004 3.09023 4.12504 1.99023 6.00005 1.99023C7.87505 1.99023 9.65005 3.09023 10.87 5.00023C11.4 5.82525 11.4 7.17025 10.87 8.00025C9.65005 9.91025 7.87505 11.0102 6.00005 11.0102ZM6.00005 2.74023C4.38504 2.74023 2.84004 3.71023 1.76004 5.40523C1.38504 5.99025 1.38504 7.01025 1.76004 7.59525C2.84004 9.29025 4.38504 10.2602 6.00005 10.2602C7.61505 10.2602 9.16005 9.29025 10.24 7.59525C10.615 7.01025 10.615 5.99025 10.24 5.40523C9.16005 3.71023 7.61505 2.74023 6.00005 2.74023Z"
            fill="currentcolor"
          />
        </g>
      </svg>{' '}
    </>
  ),
});
